import http from '@root/utils/axios/admin';

let state = {
    NewsList: [],
    HomeNewsList: [],
    New: {
        data: {},
        error: {}
    }
}

let actions = {

    fetchNewsList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('subscriber/news', { params: filter }).then((response) => {
                commit('setNewsList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },
    fetchHomeNewsList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('subscriber/home-news', { params: filter }).then((response) => {
                commit('setHomeNewsList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    fetchNew({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get('subscriber/news/' + id).then((response) => {
                commit('setNew', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },



}


let mutations = {
    setNewsList(state, data) {
        state.NewsList = data;
    },
    setHomeNewsList(state, data) {
        state.HomeNewsList = data;
    },
    setNew(state, data) {
        state.New.data = data;
    },
}

export default {
    state,
    actions,
    mutations
}